export default __webpack_public_path__ + "static/media/primary-email-number-exchange.ad240fe0.svg";